export const iconModalMapper = statusCode => {
	switch (statusCode) {
		case 'A':
		case 'STATE001':
			return 'status-line-error'
		case 'P':
		case 'N':
			return 'status-line-pending'
		case 'C':
			return 'status-line-success'
	}
}

  export const colorStatusMapperModal = statusCode => {
	switch (statusCode) {
		case 'A':
		case 'STATE001':
			return 'var(--negative)' // block
		case 'P':
		case 'N':
			return 'var(--warning)' // warning
		case 'C':
			return 'var(--positive)' // accepted
	}
}
